// extracted by mini-css-extract-plugin
export default {"projectCard":"Project_projectCard__k4+WP","cardBody":"Project_cardBody__j+Rrf","cardText":"Project_cardText__U7kXz"};